export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  { id: 'cat-1', name: '热血漫画', slug: 'rexue', icon: 'ri-fire-line', description: '激情燃烧的热血战斗，燃爆你的每一根神经', count: 1280 },
  { id: 'cat-2', name: '恋爱漫画', slug: 'lianai', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱故事，唤醒你的少女心', count: 1560 },
  { id: 'cat-3', name: '奇幻漫画', slug: 'qihuan', icon: 'ri-magic-line', description: '天马行空的奇幻世界，开启异次元冒险之旅', count: 980 },
  { id: 'cat-4', name: '都市漫画', slug: 'dushi', icon: 'ri-building-line', description: '都市生活中的酸甜苦辣，写实又治愈', count: 1120 },
  { id: 'cat-5', name: '悬疑漫画', slug: 'xuanyi', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理，每一页都让你欲罢不能', count: 650 },
  { id: 'cat-6', name: '搞笑漫画', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', description: '轻松搞笑日常，一笑解千愁', count: 890 },
  { id: 'cat-7', name: '恐怖漫画', slug: 'kongbu', icon: 'ri-ghost-line', description: '惊悚恐怖的深夜故事，胆小慎入', count: 430 },
  { id: 'cat-8', name: '古风漫画', slug: 'gufeng', icon: 'ri-landscape-line', description: '唯美古风画卷，穿越时空的爱恨情仇', count: 720 },
  { id: 'cat-9', name: 'BL漫画', slug: 'bl', icon: 'ri-user-heart-line', description: '纯爱至上，心动瞬间', count: 540 },
  { id: 'cat-10', name: '完结漫画', slug: 'wanjie', icon: 'ri-check-double-line', description: '已完结优质漫画，一口气看到爽', count: 2100 },
];